export default function parsePlaceholder ({imageData, maxSize}) {
  const items = imageData.srcset.filter(item => {
    if (item.w <= this.maxSize && item.h <= this.maxSize) {
      return item
    }
  }).sort((a, b) => {
    return a.w - b.w
  })
  console.log('%c PLACEHOLDER ITEMS', 'background: #222; color: #bada55', items[0])
  return items[0] || null
}



// WEBPACK FOOTER //
// ./src/modules/ModuleImage/utils/parsePlaceholder.js